import { useNextAvailableDates } from '../../api/productList/useNextAvailableDates';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/LoadingSpinner';

function ProductAvailableDates({ productId }: { productId: string }) {
    const { t } = useTranslation();
    const { data: availability } = useNextAvailableDates({ productId });

    if (!availability) {
        return <LoadingSpinner width={12} />;
    }

    return (
        <>
            {availability.available ? (
                <span className="available ">
                    <strong>{t('components.productStatistics.now')}</strong>
                </span>
            ) : availability.nextAvailableDate ? (
                <>
                    <span className="next-available-dates ">
                        <strong>
                            {t('dateFormat.dateWithShortMonth', {
                                val: new Date(availability.nextAvailableDate)
                            })}
                        </strong>
                    </span>
                </>
            ) : null}
        </>
    );
}

export default ProductAvailableDates;
